<template>
   <div class="media one_comment_container" :class="{'ml-4':isSubcomment==1}"  >
    <img v-if="comment.user.isanonymous && comment.user.isanonymous==true" :src="image_url+comment.user.avatar" class="mr-3 rounded-circle" alt="..." width="50" height="50">
    <router-link tag="a" v-if="!(comment.user.isanonymous && comment.user.isanonymous==true)"
        :to="{name: 'user_page_main', params: { user_id: comment.user.last_id }}"><img  :src="image_url+comment.user.avatar" class="mr-3 rounded-circle" alt="..." width="50" height="50"></router-link>
     <div class="media-body">
      <h5 v-if="comment.user.isanonymous && comment.user.isanonymous==true" class="mt-0">{{ comment.user.name }} </h5>
       <span v-if="comment.user.isanonymous && comment.user.isanonymous==true"><i class="fa fa-calendar"></i> {{ comment.created_at }}</span>
       <router-link tag="a" v-if="!(comment.user.isanonymous && comment.user.isanonymous==true)"
           :to="{name: 'user_page_main', params: { user_id: comment.user.last_id }}"><h5  class="mt-0">{{ comment.user.name }}</h5></router-link>
       <span v-if="!(comment.user.isanonymous && comment.user.isanonymous==true)"><i class="fa fa-calendar"></i> {{ comment.created_at }}</span>
      <p v-if="comment.comment" style="white-space: pre-line">{{ comment.comment }}</p>
      <editorjsrender v-if="comment.content_json && comment.content_json.blocks" ref="editorjsrender" :blocks_json="comment.content_json.blocks"></editorjsrender>
      <button v-if="isRemove" class="btn btn-red mb-1 mt-1" @click="clickRemove">Удалить</button>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";

export default {
  name: 'CommentBlock',
  data(){
    return {
      'image_url':""
    };
  },
  props: {
    comment: Object,
    isSubcomment:Number,
    isRemove:Boolean,

  },
  components: {
    'editorjsrender': Editorjsrender,
  },
  mounted() {
    var app=this;

    app.image_url = Vue.config.IMAGE_URL;

  },
  methods:{
    clickRemove(){
      this.$emit("click-remove",1);
    }
  }
}
</script>

<style scoped>
.media {
  margin-top: 1rem;
}
</style>